import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux'
import { asyncConnect } from 'redux-async-connect'
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
// import {SlideDown} from 'react-slidedown'
// import { Link as ScrollLink } from 'react-scroll'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  CompanyIsPff,
  CompanyIsWff,
  CompanyIsTff,
  CompanyIsGff,
  CompanyIsDff,
  CompanyIsFff,
  CompanyIsSjf,
} from '../../components'
import Styles from './Company.css'
import * as searchActions from 'redux/modules/search'


/**
 * <ListSlidedowns> component
 * Display: Small alerts for various issues
 * @param company: company object 
 */
@CSSModules(Styles, {allowMultiple:true})
class ListSlidedowns extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = { 
      labelConfig: {
        is_fff: ['Fossil fuels', 'fff'],
        is_dff: ['Deforestation', 'dff'],
        is_gff: ['Civilian firearms', 'gff'],
        is_pff: ['Prison industrial complex', 'pff'],
        is_wff: ['Military contractor', 'wff'],
        is_tff: ['Tobacco', 'tff'],
        is_sjf: ['Social justice', 'sjf'],
      },
    }
  }
  //
  render() {
    if (!this.props.company) return null
    return  <div>
      {Object.entries(this.state.labelConfig).map(([key, [label, shortcode]]) => {
        if (!this.props.company[key]) return null
        return <div styleName='section-wrap' key={key}>
          <div styleName='section-label' >
            {label}
          </div>
          {
            key==='is_fff' ?
              <CompanyIsFff company={this.props.company}/> :
              null
          }
          {
            key==='is_dff' ?
              <CompanyIsDff company={this.props.company}/> :
              null
          }
          {
            key==='is_gff' ?
              <CompanyIsGff company={this.props.company}/> :
              null
          }
          {
            key==='is_pff' ?
              <CompanyIsPff company={this.props.company}/> :
              null
          }
          {
            key==='is_wff' ?
              <CompanyIsWff company={this.props.company}/> :
              null
          }
          {
            key==='is_tff' ?
              <CompanyIsTff company={this.props.company}/> :
              null
          }
          {
            key==='is_sjf' ?
              <CompanyIsSjf company={this.props.company}/> :
              null
          }
        </div>
      })}
    </div>
  }
}


@connect(
  state => ({
    result: state.companydetails.result,
    loading: state.companydetails.loading,
    loaded: state.companydetails.loaded,
    error: state.companydetails.error
  }),
  searchActions)
// @asyncConnect([{
//   // need otherwise cient navigate is blocked until the page is loaded
//   deferred: true,
//   promise: ({params, store: {dispatch, getState}}) => {
//     return dispatch(
//       searchActions.companydetails(
//         params.companyId,
//       )
//     )
//   }
// }])
@CSSModules(Styles, {allowMultiple:true})
export default class Company extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      title: 'Companies',
      description: 'See how companies are rated on environmental and social sustainability issues.',
      url: config.domain + config.routes.company
    }
  }
  componentWillMount() {
    this.props.companydetails(this.props.params.companyId)
  }

  componentWillReceiveProps(nextProps) {
    const slugify = (name) => {
      return name
        .toLowerCase() // Convert to lowercase
        .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-'); // Remove extra hyphens
    }
    if (nextProps.result && nextProps.result.result && nextProps.result.result.length > 0) {
      const a = slugify(this.props.params.shortName)
      const b = slugify(nextProps.result.result[0].short_name)
      if (a !== b) {
        this.context.router.push(config.routes.company + '/' + b + '/' + this.props.params.companyId)
      }
    }
  }

  // {market, company_id, short_name, sector, legal_name, primary_symbol, primary_exchange_id, industry_code, is_po_consumer, is_po_producer, is_po_financier, is_arms, is_to, is_tm, is_ip, is_afsc_divest, is_pp, is_borders, is_cl, is_mmc, is_cm, is_nw, is_gm, is_gr, is_c2, is_f15, is_og, is_ut, is_co, is_dirty, is_pff_high, is_pff_extreme, gef_score, gef_score_a, gef_score_b, is_fossil_bank, fossil_bank_lending_total, fossil_bank_score, is_fossil_insure, fossil_insure_score, dei_score, rji_score, hrc_score, updated_at, version, id}

  /**
   * Update the company object by combining some flags.
   *
   * @param {Object} Object to update
   */
  updateCompanyObj(c) {
    c.is_fff =          (c.is_c2 || c.is_f15 || c.is_og || c.is_ut || c.is_co || c.is_fossil_bank || c.is_fossil_insure)
    c.is_pff =          (c.is_pp || c.is_borders)
    c.is_p =            (c.is_pp      && !c.is_pff_high)
    c.is_b =            (c.is_borders && !c.is_pff_high)
    c.is_prisons_high = (c.is_pp      &&  c.is_pff_high)
    c.is_borders_high = (c.is_borders &&  c.is_pff_high)
    c.is_dff =          (c.is_po_consumer || c.is_po_producer || c.is_po_financier)
    c.is_gff =          (c.is_gm || c.is_gr)
    c.is_wff =          (c.is_mmc)
    c.is_tff =          (c.is_to || c.is_tm)
    c.is_sjf =          (c.gef_score) //  || c.dei_score || c.rji_score || c.hrc_score
    return c
  }

  render() {
    if (!this.props.result) {
      return <div styleName='main'>
        <Loader
          options={{scale: 0.70, top:'2.0rem'}}
          loaded={false}
        />
      </div>
    } else if (!this.props.result.result || this.props.result.result.length<=0) {
      this.context.router.push(config.routes.notFound)
    }

    const company = this.updateCompanyObj(this.props.result.result[0])

    return <div styleName='main'>
      {
        container.helmet(
          company.short_name + ' - ' + this.state.title,
          this.state.description,
          this.state.url
        )
      }
      <ContainerDivs>

        <header styleName='header'>
          <p><Link to={config.routes.companies} title='Companies' xstrong>← Back to all companies</Link></p>
          <p styleName='name-label'>Company profile</p>
          <h1>{ company.short_name }</h1>
          <p styleName='data-label'><span>Legal name</span><span>{ company.legal_name }</span></p>
          <p styleName='data-label'><span>Primary symbol</span><span>{ company.primary_symbol }</span></p>
        </header>

        <h2>Environmental & Social Issues</h2>
        <ListSlidedowns company={company} />

      </ContainerDivs>
    <br/>
    <br/>
    <br/>
    </div>
  }
}